import React, { useCallback, useEffect, useState } from 'react';
import { useAuth, useLogin, useQueryParams, ValidatorProvider } from 'react-admin-base';
import { FormattedMessage, useIntl } from "react-intl";
import { Link, Redirect } from 'react-router-dom';
import { Alert, Button, Card, CardBody, Form, FormGroup, Input, Label } from 'reactstrap';
import { Validator, LoadingButton } from "react-admin-base-bootstrap";
import AuthLayout from 'react-admin-base-adminkit/lib/esm/Auth/Layout';
import { LanguageSwitcherBasic } from '../i18n';

const error_messages = {
  "invalid_grant": "INVALID_PASSWORD"
};

export default function Login() {
  const [ api ] = useAuth();
  const login = useLogin();
  const intl = useIntl();
  const { code } = useQueryParams();

  const [ username, setUsername] = useState('');
  const [ password, setPassword] = useState('');
  const [ loading, setLoading] = useState(false);
  const [ error, setError ] = useState(null);

  const loginByCode = useCallback(async function() {
    if (code) {
        setLoading(true);
        try {
          await api.log_in_by_code(code, window.location.origin + login.login);
        } catch(e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    }
  }, [setLoading, setError, code]);

  useEffect(function() {
      loginByCode();
  }, [loginByCode]);

  const handleSubmit = useCallback(async function(e) {
    e.preventDefault();

    if (loading)
      return false;

    setError(null);
    setLoading(true);
    try {
      await api.log_in(username, password);
    } catch(e) {
      console.error(e);

      const msg = error_messages[(e && e.message) || '-'];
      if (msg) {
        setError(new Error(intl.formatMessage({ id: msg })));
      } else {
        setError(e);
      }
    } finally {
      setLoading(false);
    }
  }, [username, password, error, loading, intl, error_messages]);

  if (code) {
    if (loading) {
      return <AuthLayout />;
    } else if (error) {
      return <Redirect to={login.login} />;
    }
  }

  return <AuthLayout>
    <p className="text-center"><FormattedMessage id="LOGIN_HEAD" /></p>

    <Card>
      <CardBody>
        <ValidatorProvider>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label><FormattedMessage id="EMAIL_ADDRESS" /></Label>
              <Validator name="username" type="required|email">
                <Input
                  type="text"
                  value={username || ''}
                  label="Email"
                  onChange={a => {
                    setUsername(a.currentTarget.value);
                    setError(null);
                  }}
                  disabled={loading}
                  autoComplete="username"
                />
              </Validator>
            </FormGroup>
            <FormGroup className="mb-0">
              <Label><FormattedMessage id="PASSWORD" /></Label>
              <Validator name="password" type="required">
                <Input
                  type="password"
                  value={password || ''}
                  label="Email"
                  onChange={a => {
                    setPassword(a.currentTarget.value);
                    setError(null);
                  }}
                  disabled={loading}
                  autoComplete="current-password"
                />
              </Validator>
            </FormGroup>
            { login.reset && <small className="mb-4">
                <FormattedMessage id="FORGOT_PASSWORD" values={{ a: text => <Link to={login.reset}>{text}</Link> }} />
            </small> }
            { error && <Alert color="danger" toggle={() => setError(null)}>{ error.message }</Alert> }
            <div className="text-center mt-4">
              <LoadingButton type="submit"  size="lg" color="primary" loading={loading}><FormattedMessage id="LOGIN" /></LoadingButton>
            </div>
          </Form>
        </ValidatorProvider>

        { login.register && <Link className={"text-decoration-none"} to={login.register}><Button type="button" color="primary" block outline className="mt-3"><FormattedMessage id="NEW_ACCOUNT" /></Button></Link>}
      </CardBody>
    </Card>
    <LanguageSwitcherBasic className="mt-3" />
  </AuthLayout>;
}